import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';

import styles from './styles';

const useStyles = createUseStyles(styles, 'SectionToolbar');

function SectionToolbar({ className, items = [], massiveToolbar, showMassiveToolbar }) {
    const classes = useStyles();
    const leftItems = useMemo(() => items.filter((item) => item.position === 'left'), [items]);
    const rightItems = useMemo(() => items.filter((item) => item.position === 'right'), [items]);
    const rootClassNames = classnames(className, classes.root, {
        [classes.showMassiveToolbar]: showMassiveToolbar,
    });

    return (
        <div className={rootClassNames}>
            <div className={classes.leftItems}>
                {leftItems.map((item, i) => (
                    <div
                        key={i}
                        className={classnames(classes.item, {
                            [classes.itemFlexGrow]: item.flexGrow,
                        })}
                    >
                        {item.component}
                    </div>
                ))}
            </div>

            <div className={classes.rightItems}>
                {rightItems.map((item, i) => (
                    <div
                        key={i}
                        className={classnames(classes.item, {
                            [classes.itemFlexGrow]: item.flexGrow,
                        })}
                    >
                        {item.component}
                    </div>
                ))}
            </div>
            <div className={classes.massiveToolbar}>{massiveToolbar}</div>
        </div>
    );
}

SectionToolbar.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            position: PropTypes.oneOf(['left', 'right']),
            component: PropTypes.node,
        }),
    ),
};

export default React.memo(SectionToolbar);
